var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  z-index: 2;\n  align-self: flex-end;\n  pointer-events: none;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  margin-left: ", "px;\n  margin-top: ", "px;\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: ", "px ", "px;\n\n  > * {\n    pointer-events: auto;\n  }\n"])), _ref => {
  var {
    $marginLeft
  } = _ref;
  return $marginLeft;
}, _ref2 => {
  var {
    $marginTop
  } = _ref2;
  return $marginTop;
}, _ref3 => {
  var {
    $marker
  } = _ref3;
  return $marker;
}, _ref4 => {
  var {
    $width
  } = _ref4;
  return $width;
}, _ref5 => {
  var {
    $height
  } = _ref5;
  return $height;
});